import {
  Avatar,
  Box,
  Dialog,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { BiAddToQueue } from 'react-icons/bi';
import IDiseaseClassification from '../../../interfaces/IDiseaseClassification';
import DeleteIcon from '@mui/icons-material/Delete';
import { MdOutlineBadge } from 'react-icons/md';
import { Span } from './MedicalCertificateForm.styled';
import { useMedicalCertificateService } from '../../../hooks/services/useMedicalCertificateService';
import Transition from '../../followup/FollowupTransition';
import FollowupDiseaseClassificationForm from '../../followup/FollowupDiseaseClassificationForm';

interface IProps {
  medicalCertificateId: string;
}

const MedicalCertificateFormCid = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [diesases, setDiseaes] = useState<IDiseaseClassification[]>([]);
  const [openCidForm, setOpenCidForm] = useState(false);

  const medicalCertificateService = useMedicalCertificateService();

  useEffect(() => {
    listDiseases();
  }, [props.medicalCertificateId]);

  const removeDisease = async (id: string): Promise<void> => {
    setLoading(true);
    medicalCertificateService
      .removeDiseasesClassification(id)
      .then(async () => {
        setLoading(false);
        await listDiseases();
      })
      .catch(() => {
        setLoading(false);
        toastr.error('Ocorreu um erro ao carregar a lista de doenças.');
      });
  };

  const listDiseases = async (): Promise<void> => {
    setLoading(true);
    medicalCertificateService
      .listDiseasesByMedicalCertificateId(props.medicalCertificateId)
      .then(result => {
        setLoading(false);
        setDiseaes(result);
      })
      .catch(() => {
        setLoading(false);
        toastr.error('Ocorreu um erro ao carregar a lista de doenças.');
      });
  };

  return (
    <Box sx={{ padding: '10px 10px 10px 0px' }}>
      <Dialog fullWidth open={openCidForm} TransitionComponent={Transition}>
        <FollowupDiseaseClassificationForm
          closeDialog={() => setOpenCidForm(false)}
          isOpen={openCidForm}
          medicalCertificateId={`${props.medicalCertificateId}`}
          handleRequest={listDiseases}
        />
      </Dialog>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2>CIDs</h2>
        <Tooltip title="Adicionar CID" placement="left">
          <IconButton sx={{ width: '50px', height: '50px' }} onClick={() => setOpenCidForm(true)}>
            <BiAddToQueue />
          </IconButton>
        </Tooltip>
      </Box>
      {loading ? <LinearProgress /> : <hr />}
      <List dense={true} sx={{ paddingLeft: '20px', paddingRight: '20px' }}>
        {diesases.map(disease => {
          return (
            <ListItem
              key={disease.id}
              secondaryAction={
                <Tooltip title="Excluir CID" placement="left">
                  <IconButton edge="end" aria-label="delete" onClick={() => removeDisease(`${disease.id}`)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              }
            >
              <ListItemAvatar>
                <Avatar>
                  <MdOutlineBadge />
                </Avatar>
              </ListItemAvatar>
              <ListItemText>
                <b>Código</b>
                <Span>{disease.code}</Span>
                <b style={{ marginLeft: '10px' }}>Descrição:</b>
                <Span>{disease.description}</Span>
              </ListItemText>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default MedicalCertificateFormCid;
